<template>
  <div
    id="app"
    :class="{
      specific: isSpecific,
    }"
    v-hb-loading.fullscreen.lock="loading"
    hb-loading-bg="#16221a"
  >
    <div class="block-1" :style="[!isSpecific ? `padding-top: ${blockPaddingTop}px` : '']">
      <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/e1909b8f1a4ec01d282c8d0bc5eb10a7.png'" alt="" class="block-1-bg" />
      <template v-if="!isSpecific">
        <div class="static">
          <div class="static-logo">
            <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/ebce4be7b9b023fd220a1b6c5fb25bc2.png'" alt="" />
          </div>
          黑盒语音 PC端内
        </div>
        <div class="mini-pro-title">
          <div class="search-box">
            <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/079a8689df28bb6027b521a01f8a75c1.png'" alt="" />
          </div>
          {{ miniProgramInfo.title }}
        </div>
        <div class="mini-pro-desc" :style="{ height: descHeight + 'px' }">
          {{ miniProgramInfo.desc }}
        </div>
        <div class="mini-pro-pic" :class="{ single: slides.length === 1 }" :style="{ top: picTop + 'px' }">
          <div class="carousel-wrapper" v-if="slides.length > 1">
            <BindCarousel :slides="slides" />
          </div>
          <div class="swiper-single" v-else>
            <div class="carousel-tag" v-if="slides[0].tag">
              <div class="tag-text">
                {{ slides[0].tag }}
              </div>
              <div class="tag-bg-pic">
                <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/8e42b78a4d0f931f24b10fb1adf381df.png'" alt="" />
              </div>
            </div>
            <div class="pic">
              <img v-src="slides[0].img" alt="" />
            </div>
          </div>
        </div>
        <CopyBlock :mini_pro_id="mini_pro_id" class="linear-block"></CopyBlock>
        <div class="operation-tips">
          <div class="tip-1">1.复制chat.top <br />前往黑盒语音官网</div>
          <div class="connector">
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.23307 0.233991C0.888908 0.55903 0.873409 1.10152 1.19845 1.44568L5.49975 6L1.19845 10.5543C0.873409 10.8985 0.888908 11.441 1.23307 11.766C1.57723 12.0911 2.11972 12.0756 2.44476 11.7314L7.3019 6.58854C7.61388 6.2582 7.61388 5.74181 7.3019 5.41147L2.44476 0.268611C2.11972 -0.075548 1.57723 -0.0910477 1.23307 0.233991Z"
                fill="white"
                fill-opacity="0.28"
              />
            </svg>
          </div>
          <div class="tip-2">2.官网下载 Windows端</div>
          <div class="connector">
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.23307 0.233991C0.888908 0.55903 0.873409 1.10152 1.19845 1.44568L5.49975 6L1.19845 10.5543C0.873409 10.8985 0.888908 11.441 1.23307 11.766C1.57723 12.0911 2.11972 12.0756 2.44476 11.7314L7.3019 6.58854C7.61388 6.2582 7.61388 5.74181 7.3019 5.41147L2.44476 0.268611C2.11972 -0.075548 1.57723 -0.0910477 1.23307 0.233991Z"
                fill="white"
                fill-opacity="0.28"
              />
            </svg>
          </div>
          <div class="tip-3">
            3.PC端内搜索:<br />
            {{ miniProgramInfo.title }}
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="specific-box"
          :style="{
            height: blockPaddingTop + 'px',
          }"
        >
          <div class="static">
            <div class="static-logo">
              <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/ebce4be7b9b023fd220a1b6c5fb25bc2.png'" alt="" />
            </div>
            黑盒语音 PC端内
          </div>
          <div class="mini-pro-title">
            <div class="search-box">
              <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/079a8689df28bb6027b521a01f8a75c1.png'" alt="" />
            </div>
            {{ miniProgramInfo.title }}
          </div>
          <div class="mini-pro-desc" :style="{ height: descHeight + 'px' }">
            {{ miniProgramInfo.desc }}
          </div>
          <div class="mini-pro-pic" :class="{ single: slides.length === 1 }" :style="{ top: picTop + 'px' }">
            <div class="carousel-wrapper" v-if="slides.length > 1">
              <BindCarousel :slides="slides" />
            </div>
            <div class="swiper-single" v-else>
              <div class="carousel-tag" v-if="slides[0].tag">
                <div class="tag-text">
                  {{ slides[0].tag }}
                </div>
                <div class="tag-bg-pic">
                  <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/8e42b78a4d0f931f24b10fb1adf381df.png'" alt="" />
                </div>
              </div>
              <div class="pic">
                <img v-src="slides[0].img" alt="" />
              </div>
            </div>
          </div>
          <CopyBlock :mini_pro_id="mini_pro_id" class="linear-block"></CopyBlock>
          <div class="operation-tips">
            <div class="tip-1">1.复制chat.top <br />前往黑盒语音官网</div>
            <div class="connector">
              <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.23307 0.233991C0.888908 0.55903 0.873409 1.10152 1.19845 1.44568L5.49975 6L1.19845 10.5543C0.873409 10.8985 0.888908 11.441 1.23307 11.766C1.57723 12.0911 2.11972 12.0756 2.44476 11.7314L7.3019 6.58854C7.61388 6.2582 7.61388 5.74181 7.3019 5.41147L2.44476 0.268611C2.11972 -0.075548 1.57723 -0.0910477 1.23307 0.233991Z"
                  fill="white"
                  fill-opacity="0.28"
                />
              </svg>
            </div>
            <div class="tip-2">2.官网下载 Windows端</div>
            <div class="connector">
              <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.23307 0.233991C0.888908 0.55903 0.873409 1.10152 1.19845 1.44568L5.49975 6L1.19845 10.5543C0.873409 10.8985 0.888908 11.441 1.23307 11.766C1.57723 12.0911 2.11972 12.0756 2.44476 11.7314L7.3019 6.58854C7.61388 6.2582 7.61388 5.74181 7.3019 5.41147L2.44476 0.268611C2.11972 -0.075548 1.57723 -0.0910477 1.23307 0.233991Z"
                  fill="white"
                  fill-opacity="0.28"
                />
              </svg>
            </div>
            <div class="tip-3">
              3.PC端内搜索:<br />
              {{ miniProgramInfo.title }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <template v-if="!isSpecific">
      <div class="block-2">
        <img v-src="'https://imgheybox.max-c.com/oa/2024/05/31/f32765449b1fcbbc44d0dac93b27feeb.png'" alt="" />
      </div>
      <div class="block-3">
        <img v-src="'https://imgheybox.max-c.com/oa/2023/04/24/b775c4d2bcd11520f113419f5b7c2689.jpeg'" alt="" class="block-3-bg" />
        <img v-src="'https://imgheybox.max-c.com/oa/2023/04/24/2e6ddb3fcd63e0504cbf39bcd479319a.png'" alt="" class="block-3-content" />
        <CopyBlock :mini_pro_id="mini_pro_id"></CopyBlock>
      </div>
    </template>
    <Toast :show.sync="showToast"></Toast>
  </div>
</template>
<script>
import { getMpShareInfo, reportExposure } from '_api/heybox-chat/mp-mobile.js';
import { wxShare } from '_lib/utils';

import BindCarousel from './components/BindCarousel.vue';
import CopyBlock from './components/CopyBlock.vue';
import Toast from './components/Toast.vue';
import { getOSType } from '@heybox-webapp/utils';

export default {
  data() {
    return {
      bgUrl: {},
      showToast: false,
      mini_pro_id: '',
      miniProgramInfo: {
        title: '',
      },
      slides: [],
      os: '',
      loading: true,
      descHeight: 24,
      picTop: 179,
      blockPaddingTop: 565,
      weixindata: {},
      shareInfo: {},

      isSpecific: false,
    };
  },
  components: {
    CopyBlock,
    Toast,
    BindCarousel,
  },
  created() {
    const SPECIFIC_MINI_PRO_ID = 'mhwilds_overlay';
    this.mini_pro_id = this.getLastPartOfUrl(window.location.href);

    // TEST
    // this.mini_pro_id = 'mhwilds_overlay';
    // this.mini_pro_id = 'valorant_overlay';

    this.isSpecific = this.mini_pro_id === SPECIFIC_MINI_PRO_ID;
    this.os = getOSType();
    if (['iOS', 'Android'].includes(this.os)) {
      this.initMiniProgramInfo();
    } else {
      window.location.replace(`https://chat.xiaoheihe.cn/app/?mini_pro_id=${this.mini_pro_id}`);
    }
  },
  methods: {
    getLastPartOfUrl(url) {
      const pathname = new URL(url).pathname;
      const parts = pathname?.split('/') || [];
      const filteredParts = parts.filter((part) => part.length > 0);
      if (filteredParts.length) {
        return filteredParts[filteredParts.length - 1];
      } else {
        return '';
      }
    },
    setElementStyle(el, styleObj) {
      if (!el) return;
      Object.assign(el.style, styleObj); // 使用 Object.assign 复制样式
    },
    getBlockHeight(desc) {
      let container = document.createElement('div');
      container.style.visibility = 'hidden';
      container.style.position = 'absolute';
      container.style.top = '-9999px';
      container.style.left = '24px';
      container.style.right = '24px';
      container.style.wordBreak = 'break-all';
      document.body.appendChild(container);

      container.innerText = desc;
      const styleObj = {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '24px',
        textAlign: 'left',
      };

      this.setElementStyle(container, styleObj);

      const res = container.getBoundingClientRect().height;
      container.remove();
      return res;
    },
    dynamicHeight() {
      this.descHeight = Math.max(24, this.getBlockHeight(this.miniProgramInfo.desc));
      this.picTop = Math.max(155 + this.descHeight, 179);
      this.blockPaddingTop = Math.max(565, 541 + this.descHeight);
    },
    async initMiniProgramInfo() {
      try {
        const {
          data: { result, status },
        } = await getMpShareInfo({
          mini_pro_id: this.mini_pro_id,
          url: window.location.origin + window.location.pathname,
        });
        if (status === 'ok') {
          const { share_page, weixin_share_data } = result;
          this.miniProgramInfo = share_page || {};
          this.weixindata = weixin_share_data || {};
          this.weixindata.appId = this.weixindata.appid;
          delete this.weixindata.appid;
          this.slides = (share_page.imgs || []).map(({ url, tag }) => {
            return { img: url, tag };
          });
          this.loading = false;
          this.initShareInfo();

          this.dynamicHeight();
          reportExposure();
        } else {
          // 如果数据获取不到，则直接跳转到移动端首页
          window.location.replace('https://chat.xiaoheihe.cn/home/mobile');
        }
      } catch (_e) {
        console.log('initMiniProgramInfo ~ _e:', _e);
        window.location.replace('https://chat.xiaoheihe.cn/home/mobile');
      }
    },
    initShareInfo() {
      this.shareInfo = {
        title: `向你推荐【${this.miniProgramInfo.title}】小程序`,
        desc: '进入黑盒语音PC客户端使用此功能！',
        imgUrl: this.miniProgramInfo.wx_img || 'https://imgheybox.max-c.com/oa/2025/02/25/8d4f7672603889f4fb32beefd88fe80f.png',
        link: window.location.origin + window.location.pathname,
      };

      document.title = this.shareInfo.title;

      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', this.shareInfo.title);
      }

      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', this.shareInfo.desc);
      }

      const ogImage = document.querySelector('meta[property="og:image"]');
      if (ogImage) {
        ogImage.setAttribute('content', this.shareInfo.imgUrl);
      }

      const ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) {
        ogUrl.setAttribute('content', this.shareInfo.link);
      }

      const description = document.querySelector('meta[name="description"]');
      if (description) {
        description.setAttribute('content', this.shareInfo.desc);
      }

      const itempropName = document.querySelector('meta[itemprop="name"]');
      if (itempropName) {
        itempropName.setAttribute('content', this.shareInfo.title);
      }
      const itempropDescription = document.querySelector('meta[itemprop="description"]');
      if (itempropDescription) {
        itempropDescription.setAttribute('content', this.shareInfo.desc);
      }
      const itempropImage = document.querySelector('meta[itemprop="image"]');
      if (itempropImage) {
        itempropImage.setAttribute('content', this.shareInfo.imgUrl);
      }
      const ua = navigator.userAgent.toLowerCase();
      if (/MicroMessenger/i.test(ua)) {
        wxShare(this.weixindata, this.shareInfo);
      }
    },
  },
};
</script>
<style lang="less">
@import '~_style/common.css';
@import './assets/css/common.less';

body {
  background: #16221a;
}
#app {
  overflow: hidden;
  &.specific {
    .specific-box {
      height: fit-content;
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    .block-1 {
      padding-top: 100vh !important;
    }
  }
}
.block {
  &-1,
  &-2,
  &-3 {
    width: 100%;
    position: relative;
    height: 0;
    img,
    .copy-block {
      position: absolute;
      object-fit: cover;
    }
  }

  &-1 {
    padding-top: 565px;

    .block-1-bg {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .block-1-content {
      top: 0;
      left: 0;
      width: 100%;
    }

    .copy-block {
      left: 24px;
      right: 24px;
      bottom: 105px;
    }

    .static {
      position: absolute;
      top: 32px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      gap: 8px;
      .static-logo {
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        img {
          width: 26px;
          height: 26px;
          object-fit: contain;
        }
      }
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      line-height: normal;
      white-space: nowrap;
    }
    .mini-pro-title {
      position: absolute;
      top: 68px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      text-align: center;
      font-size: 32px;
      font-weight: 600;
      line-height: normal;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      white-space: nowrap;
      .search-box {
        width: 34px;
        height: 34px;
        img {
          width: 34px;
          height: 34px;
        }
      }
    }
    .mini-pro-desc {
      position: absolute;
      top: 123px;
      left: 24px;
      right: 24px;
      color: #d9ffaf;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      opacity: 0.8;
      word-break: break-all;
    }
    .mini-pro-pic {
      position: absolute;
      max-width: 480px;
      width: 100vw;

      &.single {
        .swiper-single {
          position: absolute;
          opacity: 1;
          left: 50%;
          transform: translateX(-50%);
          width: 271px;
          height: 178px;
          border-radius: 12px;
          padding: 4px;
          border: 0.5px solid rgba(255, 255, 255, 0.2);
          background: linear-gradient(225deg, #265350 0%, #5b7662 36.62%, #9c9060 75.81%, #8e8c3e 98.43%);
          .carousel-tag {
            visibility: visible;
          }
          &.swiper-slide-active {
            opacity: 1;
            z-index: 100;
            scale: 1;
            .carousel-tag {
              visibility: visible;
            }
          }

          .pic {
            width: 100%;
            height: 100%;
            img {
              width: 263px;
              height: 170px;
              border-radius: 8px;
            }
          }
        }
      }
      .carousel-tag {
        display: flex;
        height: 30px;
        padding: 0px 14px;
        align-items: center;
        border-radius: 15px;
        background: linear-gradient(90deg, #006977 0%, #1a7851 50%, #639038 100%);

        z-index: 100;
        position: absolute;
        top: -10px;
        right: -6px;
        .tag-text {
          color: #d9ffaf;
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
        }
        .tag-bg-pic {
          width: 43px;
          height: 100%;
          position: absolute;
          right: 0px;
          img {
            height: 100%;
          }
        }
      }
    }
    .operation-tips {
      position: absolute;
      left: 24px;
      right: 27px;
      bottom: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-size: 12px;
      line-height: normal;
      .connector {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .tip {
        &-1 {
          width: 96px;
        }
        &-2 {
          width: 63px;
        }
        &-3 {
          width: 96px;
        }
      }
    }
  }
  &-2 {
    padding-top: 292%;
    img {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  &-3 {
    padding-top: 80.5%;
    .block-3-bg {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .block-3-content {
      top: 0;
      left: 0;
      width: 100%;
    }
    .copy-block {
      left: 24px;
      right: 24px;
      bottom: 46px;
    }
  }
}
</style>
